export default __webpack_public_path__ + "static/media/9.70ed221c.jpg";